<template>
  <!-- @RenderPage("Shared/_ModalsView.cshtml") -->
  <transition v-cloak name="modal">
    <v-modal
      :is-open="open"
      modal-class="alt-modal"
      data-test-basket-modal-add-proposal
      max-width="800px"
      @close="$emit('close')"
    >
      <template #content>
        <div>
          <navigation-list :datasource="datasource" />
        </div>
      </template>
    </v-modal>
  </transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import NavigationList from '../Navigation/NavigationList.vue';

export default defineComponent({
  name: 'AddProposalModal',
  components: {
    NavigationList
  },
  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    datasource: {
      type: String,
      default: () => ''
    }
  }
});
</script>
